import React from 'react';
import { useIdioma } from '../../i18n/idioma';
import { ChevronRight } from 'lucide-react';
import { RAZA_QUICK_PROMPTS } from './razaQuickPrompts';

interface RazaQuickPromptPickerProps {
  onSelect: (prompt: string) => void;
  /** Tighter spacing for the floating panel */
  compact?: boolean;
}

const RazaQuickPromptPicker: React.FC<RazaQuickPromptPickerProps> = ({ onSelect, compact = false }) => {
    const { t } = useIdioma();
  return (
    <div className={`w-full ${compact ? 'space-y-2' : 'space-y-2.5'}`}>
      <p className={`label-ui text-left ${compact ? 'mb-2' : 'mb-3'}`}>
        {t('ia.sugerencias.titulo')}
      </p>
      {RAZA_QUICK_PROMPTS.map(item => (
        <button
          key={item.label}
          type="button"
          onClick={() => onSelect(t(item.prompt))}
          className={`presionable w-full text-left bg-white border border-acero-200 rounded-xl group flex items-center gap-3
            transition-colors duration-150 hover:border-brand-400 hover:bg-brand-50
            focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 ${
            compact ? 'px-3 py-2.5' : 'px-4 py-3.5'
          }`}
        >
          <div className="flex-1 min-w-0">
            <p className={`font-semibold tracking-tight text-navy-950 ${compact ? 'text-sm' : 'text-[15px]'}`}>
              {t(item.label)}
            </p>
            <p className={`text-acero-500 mt-0.5 ${compact ? 'text-[11px]' : 'text-xs'}`}>
              {t(item.hint)}
            </p>
          </div>
          <ChevronRight
            size={compact ? 16 : 18}
            className="text-acero-300 group-hover:text-navy-950 shrink-0 transition-colors duration-150"
            aria-hidden="true"
          />
        </button>
      ))}
    </div>
  );
};

export default RazaQuickPromptPicker;
